import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TruthBomb } from './components/TruthBomb';
import { ProductReveal } from './components/ProductReveal';
import { AudienceFit } from './components/AudienceFit';
import { WhatIncludes } from './components/WhatIncludes';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalClose } from './components/FinalClose';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen w-full bg-cream overflow-x-hidden selection:bg-teal/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <TruthBomb data-id="element-3" />
      <ProductReveal data-id="element-4" />
      <AudienceFit data-id="element-5" />
      <WhatIncludes data-id="element-6" />
      <Transformation data-id="element-7" />
      <Guarantee data-id="element-8" />
      <FAQ data-id="element-9" />
      <FinalClose data-id="element-10" />
    </main>;
}